import { AuthUserPayload } from '@/api/auth/types'
import { REFRESH_KEY, TOKEN_KEY } from '@/constants/authKeys'
import { SecureStorage } from '@aparajita/capacitor-secure-storage'
import { jwtDecode } from 'jwt-decode'

export const authUtils = {
  isTokenValid(token: string | null): boolean {
    if (!token) return false
    const { exp } = jwtDecode<AuthUserPayload>(token)
    return !!exp && exp * 1000 > Date.now()
  },
  async setStoredTokens(access: string, refresh: string) {
    await Promise.allSettled([SecureStorage.set(TOKEN_KEY, access), SecureStorage.set(REFRESH_KEY, refresh)])
  },

  async clearStoredTokens() {
    await Promise.allSettled([SecureStorage.remove(TOKEN_KEY), SecureStorage.remove(REFRESH_KEY)])
  },

  async getStoredTokens() {
    const [tokenResult, refreshResult] = await Promise.allSettled([
      SecureStorage.get(TOKEN_KEY),
      SecureStorage.get(REFRESH_KEY),
    ])

    const accessToken = tokenResult.status === 'fulfilled' ? (tokenResult.value as string | null) : null
    const refreshTokenStr = refreshResult.status === 'fulfilled' ? (refreshResult.value as string | null) : null
    return { accessToken, refreshTokenStr }
  },
}
